import { render, staticRenderFns } from "./ClinicSchedule.vue?vue&type=template&id=00201b7f&scoped=true&"
import script from "./ClinicSchedule.vue?vue&type=script&lang=js&"
export * from "./ClinicSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ClinicSchedule.vue?vue&type=style&index=0&id=00201b7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00201b7f",
  null
  
)

export default component.exports